import { PageVariables } from '../variables';

/**
 * 设置页面变量
 * 神策没有页面级变量，手动去为当前页面添加需要的页面级变量
 * @template T
 * @param {T} variables
 */
const setPageVariables = <T extends PageVariables>(variables: T) => {
  // if (gioIsValid()) {
  //   window.gio('page.set', variables);
  // }
};

export default setPageVariables;
